import { Controller } from "@hotwired/stimulus";

/**
 * ハンバーガーメニューの開閉を管理するStimulusコントローラー
 *
 * 使用場所:
 * - 全画面共通のヘッダー部分（モバイル表示時）
 *
 * 主な機能:
 * - ハンバーガーメニューの開閉制御
 * - スライドインアニメーション（右から左へ）
 * - オーバーレイ表示・非表示
 * - 背景スクロール制御（メニュー表示時に無効化）
 * - オーバーレイクリックでの閉じる機能
 *
 * 必要なターゲット要素:
 * - menu: メニュー本体
 * - overlay: 背景オーバーレイ
 *
 * カスタムCSSクラス使用:
 * - Bootstrap/Tailwindとの競合回避のためcustom-*クラスを使用
 */
export default class extends Controller {
  static targets = ["menu", "overlay"];

  connect() {
    this.isOpen = false;
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    // 背景スクロールを無効化
    document.body.style.overflow = "hidden";

    // 元: this.menuTarget.classList.remove("hidden");
    // 元: this.overlayTarget.classList.remove("hidden");
    this.menuTarget.classList.remove("custom-hidden");
    this.overlayTarget.classList.remove("custom-hidden");
    this.menuTarget.classList.add("custom-visible");

    // メニューをスライドイン
    setTimeout(() => {
      // 元: this.menuTarget.classList.remove("translate-x-full");
      // 元: this.overlayTarget.classList.remove("opacity-0");
      this.menuTarget.classList.remove("custom-translate-x-full");
      this.menuTarget.classList.add("custom-translate-x-0");
      this.overlayTarget.classList.remove("custom-opacity-0");
      this.overlayTarget.classList.add("custom-opacity-1");
    }, 10);
  }

  close() {
    this.isOpen = false;
    // 背景スクロールを復元
    document.body.style.overflow = "";

    // 元: this.menuTarget.classList.add("translate-x-full");
    // 元: this.overlayTarget.classList.add("opacity-0");
    this.menuTarget.classList.remove("custom-translate-x-0");
    this.menuTarget.classList.add("custom-translate-x-full");
    this.overlayTarget.classList.remove("custom-opacity-1");
    this.overlayTarget.classList.add("custom-opacity-0");

    // アニメーション完了後に非表示
    setTimeout(() => {
      // 元: this.menuTarget.classList.add("hidden");
      // 元: this.overlayTarget.classList.add("hidden");
      this.menuTarget.classList.add("custom-hidden");
      this.overlayTarget.classList.add("custom-hidden");
      this.menuTarget.classList.remove("custom-visible");
    }, 300);
  }

  closeOnOverlay(event) {
    if (event.target === this.overlayTarget) {
      this.close();
    }
  }
}
